import React, { useEffect, useState } from 'react';
import TabScroll from '#components/navigation/tabs/tabsScroll/TabScroll';
import TabsItem from '#components/navigation/tabs/tabsItem/TabsItem';

export interface ITabItem {
  id: number;
  title?: string;
  [key: string]: string | number | unknown;
  count?: number;
}

type Props = {
  items: ITabItem[];
  onChange?: (item: ITabItem) => void;
  selectedOption?: ITabItem;
  isButtonStyle?: boolean;
};

const TabNavigator = ({
  items,
  onChange,
  isButtonStyle,
  selectedOption,
}: Props) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleItemClick = (index, item) => {
    if (index !== selectedIndex) {
      setSelectedIndex(index);
      onChange?.(item);
    }
  };

  useEffect(() => {
    const index = Math.max(
      0,
      items.findIndex((item) => item.id === selectedOption?.id)
    );
    setSelectedIndex(index);
  }, [selectedOption]);

  return (
    <TabScroll isStyleButton={isButtonStyle}>
      {items.map((item, index) => (
        <TabsItem
          id={item.id}
          key={item.id}
          text={item.title}
          count={item.count}
          isButtonStyle={isButtonStyle}
          ariaSelected={selectedIndex === index}
          handleOnClick={() => {
            handleItemClick(index, item);
          }}
        />
      ))}
    </TabScroll>
  );
};

export default TabNavigator;
